import { SketchPicker } from "react-color";
import { ColorPickerWrapper, FieldWrapper, ResetButton } from "./styled";
import { useSettings } from "../../../context";
import { getIcon } from "../../../../../../../utils/get-icon";

const BackgroundConfiguration = () => {
  const { updateBackgroundSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  const handleBackgroundColorChange = (colorResult: any) => {
    updateBackgroundSettings({ color: colorResult });
  };

  const onResetBackgroundColor = () => {
    updateBackgroundSettings({ color: "transparent" });
  };

  return (
    <FieldWrapper>
      <ColorPickerWrapper>
        <SketchPicker
          color={currentSettings.configuration.background.color}
          onChange={handleBackgroundColorChange}
          onChangeComplete={handleBackgroundColorChange}
        />
      </ColorPickerWrapper>
      <ResetButton onClick={onResetBackgroundColor}>
        {getIcon("remove")}
      </ResetButton>
    </FieldWrapper>
  );
};

export default BackgroundConfiguration;
